import React from "react";
const AuthUserContext = React.createContext(null);
const ProgressContext = React.createContext(null);
export { AuthUserContext, ProgressContext };
